<template>
	<div>
		<NavBar :groupInfo="groupInfo" :demoInfo="demoInfo" active="people" />
		<v-layout row wrap style = "background:url('https://i.postimg.cc/NGps0dqN/headline.png');" class = "elevation-1">
            <v-flex xs12 class="text-xs-center pt-4 ">
                <div class = "mb-2" :style = "{color:this.$color.primary,fontSize:5.0 + 'rem',fontFamily:'Calluns !important'}">Members</div>
                <div class = "display-1 mb-4" style="color:grey">星星之火 生生不息</div>
            </v-flex>
        </v-layout>
        <v-layout row wrap align-start class ="my-3 people-layout">
            <v-flex xs12 sm3 md2 text-xs-center class="people-sidebar">
                <v-item-group v-model="peopleSlotWindow" class="shrink" mandatory tag="v-flex">
                    <v-item v-for="(sl,sl_i) in peopleSlots" :key="sl_i">
                        <div slot-scope="{ active, toggle }" >
                            <v-btn :input-value="active" flat @click="toggle" class="people-slot-btn">
                                <span class="people-slot-label">{{sl.abre}}</span>
                                <v-icon :color="sl.logan" class= "ml-2">radio_button_checked</v-icon>
                            </v-btn>
                        </div>
                    </v-item>
                </v-item-group>
            </v-flex>
            <v-flex xs12 sm9 md10 text-xs-left class="people-window-wrap">
                <v-window v-model="peopleSlotWindow" class="elevation-1 people-window" vertical>
                    <v-window-item  v-for="(sl,sl_i) in peopleSlots" :key="sl_i" >
                        <v-card flat>
                            <v-card-text>
                            <v-layout align-center mb-3>
                                <v-icon :color="sl.logan" class="mr-3">radio_button_checked</v-icon>
                                <strong class="title">{{sl.name}}</strong>
                                <v-spacer></v-spacer>
                                <v-icon>people</v-icon>
                            </v-layout>
                            <v-card class = "eleavation-1" v-for="(member,m_id) in sl.members" :key="m_id" >
                                <v-card class="elevation-2 text-xs-center" >
                                    <div class="pa-2">
                                        <v-layout align-start class = "text-xs-left">
                                            <v-flex xs12 sm4 md3 class="people-photo">
                                                <v-img :src="people[member].picture" height = "170px" width ="170px" class="ml-3 people-image" :aspect-ratio="1" contain lazy>
                                                    <template v-slot:placeholder>
                                                        <v-layout fill-height align-center justify-center ma-0>
                                                            <v-progress-circular indeterminate color="purple"></v-progress-circular>
                                                        </v-layout>
                                                    </template>
                                                </v-img>
                                            </v-flex>
                                            <v-flex xs12 sm8 md9 class="people-card-text">
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm6>
                                                        <div class="display-1 people-name" :style="{color:$color.primary,fontFamily:'Calluns !important'}">{{people[member].name}}</div>
                                                    </v-flex>
                                                    <v-divider></v-divider>
                                                    <v-flex xs12 sm6 class ="text-xs-right" id = "people-group">
                                                        <span :style="{color:$color.primary,fontFamily:'Calluns !important'}"  class = "title mr-3" v-if="Object.keys(people[member].groups).length > 0">Teams:</span>
                                                        <template v-for="(lo,l_id) in people[member].groups">
                                                            <v-tooltip top :key="l_id * m_id"  class = "limit-logan-offset">
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn :color="lo" fab style="height:30px;width:30px;" v-on="on" ></v-btn>
                                                                </template>
                                                                <span >{{getGroupFromLogan(lo)}}</span>
                                                            </v-tooltip>
                                                        </template>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <div class="subheading my-2">{{people[member].position + " at " + people[member].school}}</div>
                                                    </v-flex>
                                                    <v-flex xs12 mb-1>
                                                        <v-divider></v-divider>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <div class = "v-btn__content my-1" style="justify-content:left;font-family:Circular;">
                                                            <v-icon left class="people-icon">email</v-icon>
                                                            <span class ="subheading people-email">{{people[member].email}}</span>
                                                        </div>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                         <div class = "v-btn__content my-1" style="justify-content:left;font-family:Circular;">
                                                            <v-icon left class="people-icon">web</v-icon>
                                                            <a class="subheading people-link" :href="people[member].website" target="_blank" style="color:black">{{people[member].website}}</a>
                                                        </div>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                         <div class = "v-btn__content my-1 people-skills" style="justify-content:left;font-family:Circular;">
                                                            <v-icon left class="people-skills-icon">gamepad</v-icon>
                                                            <span class="people-skills-text subheading">{{formatAllSkills(people[member].skills)}}</span>
                                                        </div>
                                                    </v-flex>
                                                </v-layout>


                                            </v-flex>
                                        </v-layout>
                                    </div>
                                </v-card>
                            </v-card>
                            </v-card-text>
                        </v-card>
                        </v-window-item>
                    <v-container grid-list-md text-xs-center>
                        <v-layout row wrap class = "mt-4 group-photo-grid">
                            <v-flex v-for="(card, index) in groupPhotos" :key="index" xs12 sm6 md4>
                                <v-hover>
                                    <v-card class="v-card__text" color="grey lighten-4" style="cursor: pointer;"
                                        @click="toggleEnlarge(index)" :class="{ enlarged: card.isEnlarged }" hover >
                                        <v-img :src="card.image" :aspect-ratio="4/3" max-height="90%" max-width="100%" contain lazy class="group-photo-image">
                                            <template v-slot:placeholder>
                                                <v-layout fill-height align-center justify-center ma-0>
                                                    <v-progress-circular indeterminate color="purple"></v-progress-circular>
                                                </v-layout>
                                            </template>
                                        </v-img>
                                        <v-card-text v-if="!card.isEnlarged" class="pt-4" style="position: relative;min-height:80px;padding-bottom: 0">
                                            <div class="mb-2" :style="{fontFamily: 'Calluns !important', fontSize: '1.6rem', textAlign: 'center'}">{{card.title}}</div>
                                        </v-card-text>
                                        <v-card-text v-if="card.isEnlarged" class="pt-4 group-photo-caption" style="position: relative;min-height:60px;">
                                            <div class="mb-2 group-photo-caption-text" :style="{fontFamily: 'Calluns !important', fontSize: '1.6rem', textAlign: 'center'}">{{card.subtitle}}</div>
                                        </v-card-text>
                                    </v-card>
                                </v-hover>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-window>
            </v-flex>
        </v-layout>


      <div v-if="isAnyPhotoEnlarged" class="background-mask" @click="shrinkAllPhotos"></div>

	</div>
</template>

<script>
import NavBar from './NavBar'
export default {
  name: 'People',
  components:{NavBar},
  data() {
    return {
        peopleSlotWindow:0,
        defaultPic:"https://i.postimg.cc/GpKN1pgY/2.jpg",
        groupInfo:[{name:"",introPic:"",intro:"",description:"",logan:""}],
		people:[ {alumni: "", email: "", groups: [], id: 1, label: "", name: "", picture: "", position: "", school: "", skills: [],website:""}],
        peopleSlots:[{name:"Faculty",logan:"red",abre:"Faculty",members:[]},{name:"Graduate Students/Visiting Schorlars",logan:"blue",abre:"Graduate Students",members:[]},
                        {name:"Undergraduate",logan:"green",abre:"Undergraduate",members:[]},{name:"Alumni",logan:"pink",abre:"Alumni",members:[]},{name:"Memories",logan:"grey",abre:"Memories",members:[]}],
        demoInfo:[
            {name:"Interactive Rainbow Score", address:"/demo/IRS"}
        ],
        groupPhotos: [{
            title: '2026 visiting YNU (yes, it looks like “NYU” again)',
            image: "/memories/2026-ynu-visit.jpg",
            subtitle: '2026 visiting YNU (yes, it looks like “NYU” again)',
            isEnlarged: false,
        },{
            title: '2025 Home Party: Research, Play, and Cook.',
            image: "/memories/2025-home-party.jpg",
            subtitle: '2025 Home Party: Research, Play, and Cook.',
            isEnlarged: false,
        },{
            title: '2025 cross-team gathering at NUS',
            image: "/memories/2025-nus-cross-team-gathering.jpg",
            subtitle: '2025 cross-team gathering at NUS',
            isEnlarged: false,
        },{
            title: '2024 Music AI workshop at “NYU” (Nan Yi University 南艺）',
            image: "/memories/2024-nanyi-music-ai-workshop.jpg",
            subtitle: '2024 Music AI workshop at “NYU” (Nan Yi University 南艺）',
            isEnlarged: false,
        },{
            title: '2023 autumn: Italy Demo Tour',
            image: "https://s2.loli.net/2024/01/11/4pduU3zbWfYqPQR.jpg",
            subtitle: 'Complete script: (Gus) Hi Teo! (Teo) Hi Gus, long time no see. [Unrecognizable machine failure noise]',
            isEnlarged: false,
        },{
            title: '2023 summer',
            image: "https://s2.loli.net/2024/01/11/RVZckQ2xGu3PtYb.jpg",
            subtitle: 'Featuring the SET puzzle. Here is a SET puzzle for you: [11] (①①) [22] [⑵⑵] (111) [222] [①] {③} (222) [②] {⑶⑶} [⑵⑵⑵]',
            isEnlarged: false,
        },{
            title: '2022: Music AI Concert at Abu Dhabi, hosted by MBZUAI',
            image: "https://s2.loli.net/2023/06/19/n16LExusAyrChdN.jpg",
            subtitle: 'This is a very special summer with wonderful adventures. Thank you, MBZUAI; thank you, my dear friends and students. This is just a prelude!',
            isEnlarged: false,
        },{
            title: '2021 summer: Post-NIME Music X Lab Concert in July',
            image: "https://s2.loli.net/2023/06/19/dMwNYSGIl5sD1Wh.jpg",
            subtitle: '星辰学子，一轮明月。\n' +
                '毕业生们，学海无涯，光阴转瞬，愿精彩前路不忘赤子初心。',
            isEnlarged: false,
        },{
            title: '2020 summer',
            image: "https://s2.loli.net/2023/06/19/pjF37KOU5ht4qIS.jpg",
            subtitle: 'Generation after generation, better music generation.',
            isEnlarged: false,
        },{
            title: '2019 summer',
            image: "https://s2.loli.net/2023/06/19/4XhpwJaW6mOilHG.jpg",
            subtitle: '年年岁岁聚又别，岁岁年年道又同，但有诚心求归途，不辞恒作掌灯人。 毕业生们，再见，记得读书。',
            isEnlarged: false,
        },{
            title: '2018 summer',
            image: "https://i.loli.net/2020/07/26/OH5d2kAynNXcTFC.jpg",
            subtitle: 'Music X Lab\'s first graduation dinner.',
            isEnlarged: false,
        },
        ]
    }
  },
  computed: {
    isAnyPhotoEnlarged() {
      return this.groupPhotos.some(photo => photo.isEnlarged);
    },
  },
  mounted() {
      this.getPeopleInfo()
  },
  props: {
    msg: String
  },
  methods: {
    switchToPage:function(url) {
		window.location.href=url
	},
    toggleEnlarge(index) {
      this.groupPhotos[index].isEnlarged = !this.groupPhotos[index].isEnlarged;
    },
    shrinkAllPhotos() {
      this.groupPhotos.forEach(photo => {
        photo.isEnlarged = false;
      });
    },
    getGroupFromLogan(logan) {
        for(let i in this.groupInfo) {
            if(this.groupInfo[i].logan == logan) {
                return this.groupInfo[i].name
            }
        }
        return ""
    },
    formatAllSkills(skills) {
        if (!skills) {
            return ''
        }
        // Handle both array and object formats
        let skillsArray = []
        if (Array.isArray(skills)) {
            skillsArray = skills
        } else if (typeof skills === 'object') {
            // Convert object to array
            skillsArray = Object.values(skills)
        } else {
            return ''
        }
        
        if (skillsArray.length === 0) {
            return ''
        }
        
        return skillsArray.map((skill) => {
            if (!skill) return ''
            const cleaned = String(skill).replace(/\n/g, '').trim()
            if (!cleaned) return ''
            const formatted = cleaned.charAt(0).toUpperCase() + cleaned.slice(1)
            return formatted
        }).filter(s => s !== '').join(', ')
    },
    getPeopleInfo() {
        let that = this
        this.$axios.get("/person/id/list").then(function(res) {
            that.people = res.data
            for(let i in that.people) {
                that.people[i].link = ""
                if (that.people[i].website != "" && (that.people[i].website.slice(0,4)).toLowerCase() != "http") {
                    that.people[i].website = "http://" + that.people[i].website
                }
                that.people[i].position = that.people[i].position.charAt(0).toUpperCase() + that.people[i].position.slice(1)
                if(that.people[i].picture == "") 
                    that.people[i].picture = that.defaultPic
                for(let j in that.peopleSlots) {
                    if(that.people[i].label == that.peopleSlots[j].name) {
                        that.peopleSlots[j].members.push(i)
                        break
                    }
                }
            }
		}).catch(function() {
			// Error loading people info
		})
		this.$axios.get("/group/id/list").then(function(res) {
			that.groupInfo = []
			for(let i in res.data) {
				that.groupInfo.push({
					name:res.data[i].name,
					intro:res.data[i].intro,
					introPic:res.data[i].picture,
					description:res.data[i].keywords,
					logan:res.data[i].color
				})
			}
		}).catch(function() {
			// Error loading group info
		})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.test-class {
    height:auto !important;
}
.limit__height__class .v-list__tile {
    height: auto !important;
}
.limit-logan-offset .v-tooltip__content {
    left:auto !important;
    text-align: left !important;

    
}

.scroll-y { 
    -ms-overflow-style:none;
}
.scroll-y:hover { 
    -ms-overflow-style:-ms-autohiding-scrollbar;
}
.scroll-y::-webkit-scrollbar { 
    width: 0.5vw;
    height: 1px;
    display: none;
}
.scroll-y:hover::-webkit-scrollbar { 
    display: flex;
}
.scroll-y::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px #657C88;
    background:#657C88;
}


.avatar-scrolling {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style:none;
    scrollbar-face-color: #657C88;
    transition: all 0.5s;
}
.avatar-scrolling:hover {
    /* opacity: 1; */
    -ms-overflow-style:-ms-autohiding-scrollbar;
    transition: all 0.5s;
}
.avatar-scrolling::-webkit-scrollbar {
    width: 0;
    height: 0;
} 
.avatar-scrolling:hover::-webkit-scrollbar {
    width: 1px;
    height: 0.5vh; 
} 
.avatar-scrolling::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 5px #657C88;
    background:#657C88;
}
.avatar-el {
    display:flex;
    flex-flow:column;
}
.enlarged {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 10000;
}
/* Let the photo shrink so the caption always stays inside the card */
.enlarged >>> .group-photo-image {
  flex: 0 1 auto;
  min-height: 0;
  max-height: none !important;
}
.enlarged >>> .group-photo-caption {
  flex: 0 0 auto;
  max-height: 40vh;
  overflow-y: auto;
}
.enlarged >>> .group-photo-caption-text {
  white-space: pre-line;
  overflow-wrap: anywhere;
}
.background-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}
.people-slot-btn {
    width: 100%;
    justify-content: center;
    text-align: center;
    padding: 8px 10px !important;
}
.people-slot-label {
    display: inline-block;
}
.people-photo {
    text-align: center;
}
.people-name {
    word-break: break-word;
    overflow-wrap: anywhere;
}
.people-skills {
    display: flex !important;
    align-items: flex-start !important;
    flex-wrap: nowrap !important;
}
.people-icon {
    margin-right: 8px !important;
}
.people-skills-icon {
    flex-shrink: 0 !important;
    margin-right: 8px !important;
}
.people-skills-text {
    flex: 1 1 auto !important;
    min-width: 0 !important;
    display: inline-block !important;
    white-space: normal;
}
.people-link {
    word-break: break-all;
    overflow-wrap: anywhere;
    white-space: normal;
}
.people-email {
    word-break: break-all;
    overflow-wrap: anywhere;
    white-space: normal;
}
@media (max-width: 960px) {
    .people-layout {
        flex-direction: column !important;
        padding-left: 8px;
        padding-right: 8px;
    }
    .people-sidebar {
        text-align: center !important;
        width: 100% !important;
        max-width: 100% !important;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
        margin-left: auto !important;
        margin-right: auto !important;
    }
    .people-sidebar .v-item-group {
        width: auto !important;
        max-width: 100% !important;
        margin: 0 auto !important;
    }
    .group-photo-grid > .v-flex {
        flex: 0 0 50%;
        max-width: 50%;
    }
    .people-image {
        height: 120px !important;
        width: 120px !important;
        max-width: 120px !important;
        margin-left: auto !important;
        margin-right: auto !important;
    }
}
@media (max-width: 600px) {
    .people-slot-btn {
        font-size: 0.95rem !important;
        padding: 6px 10px !important;
    }
    .group-photo-grid > .v-flex {
        flex: 0 0 100%;
        max-width: 100%;
    }
    .people-image {
        height: 100px !important;
        width: 100px !important;
        max-width: 100px !important;
    }
}
.people-card-text {
    word-break: break-word;
    overflow-wrap: anywhere;
}
</style>
